function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

const SvgVim = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10em",
    height: "10em",
    viewBox: "0 0 550 550",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-69.980994,-160.33288)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3699",
    transform: "matrix(1.532388,0,0,1.3939671,-54.912136,-41.792396)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2836",
    d: "M 260.50744,170.69515 105.98412,340.79094 259.8636,510.178 414.38691,340.08221 260.50744,170.69515 z",
    style: {
      fill: "#019833",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "0.94571567px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2838",
    d: "m 259.8636,171.40389 0,-14.88338 -168.044108,184.97916 14.164628,0 153.87948,-170.09578 z",
    style: {
      fill: "#66fe98",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "0.94571567px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#45fe02",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "0.94571567px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 259.47729,171.40389 0,-14.88338 168.0441,184.97916 -14.16463,0 -153.87947,-170.09578 z",
    id: "path2840"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#017d17",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "0.94571567px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 259.8636,511.17022 0,14.88338 -168.044108,-184.97916 14.164628,0 153.87948,170.09578 z",
    id: "path2842"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3650",
    d: "m 122.99448,175.30643 108.35396,0 6.60139,7.26665 0,22.30116 -5.23559,7.01608 -11.83699,0 0,110.75406 101.98019,-110.75406 -16.84494,0 -5.9185,-7.01608 0,-23.55403 5.46323,-5.51264 109.71976,0 5.46322,6.01379 0,22.05058 -248.12143,280.14258 -28.22666,0 -8.17033,-5.19252 0,-267.93397 -13.68257,0 -5.00795,-5.51264 0,-23.55403 5.46321,-6.51493 z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 18.91431427,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2844",
    d: "m 259.47729,511.17022 0,14.88338 168.0441,-184.97916 -14.16463,0 -153.87947,170.09578 z",
    style: {
      fill: "#005d04",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "0.94571567px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 5.67429399,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeDasharray: "none"
    },
    d: "M 259.41018,155.14848 90.734026,340.82339 258.70737,525.72467 427.38353,340.04975 259.41018,155.14848 z",
    id: "path2846"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3640",
    d: "m 232.50008,186.64163 6.11655,-3.54366 -6.27751,-6.91014 -109.29305,0 -5.55319,6.11281 0,23.1224 6.15679,6.77725 2.93756,-6.77725 -3.86308,-4.2524 0,-16.30085 2.89731,-2.83492 104.30324,0 2.57538,4.60676 z",
    style: {
      fill: "#fefefe",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "0.94571567px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(0.90138601,0,0,0.99222542,-437.42287,-185.30615)",
    d: "m 828.9375,369.5 -4.28125,4.28125 0,15.71875 3.75,3.75 19.8125,0 0,15.1875 -131.0625,132.84375 0,-147.84375 21.78125,0 4.46875,-4.46875 0,-15.90625 -4.125,-3.1875 -114.625,0 -3.75,3.75 0,16.25 3.8125,3.8125 19.9375,0 0,272.25 3.75,3.75 22.65625,0 274.65625,-283.40625 0,-12.5 -4.28125,-4.28125 -112.5,0 z",
    id: "path3632",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3646",
    d: "m 143.48158,204.87424 0,270.62073 3.18688,4.0092 -2.49916,5.24301 -7.06148,-7.74876 0,-265.1081 z",
    style: {
      fill: "#fefefe",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "0.94571567px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3644",
    d: "m 125.82451,204.87424 -1.82108,6.51494 13.2028,0 7.2843,-6.51494 -18.66602,0 z",
    style: {
      fill: "#808080",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "0.94571567px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3638",
    d: "m 307.18636,212.19144 2.89731,-6.55577 -4.18501,-4.2524 0,-14.52901 4.82886,-5.31551 100.76208,0 3.86308,5.66987 5.4727,-4.2524 -5.63366,-6.20141 -108.32729,0 -5.39221,5.93564 0,23.29957 5.59342,5.80276 m -87.54309,111.87785 -10.52288,28.10566 118.7898,-131.1155 0,-15.59211 -108.26692,118.60195 z",
    style: {
      fill: "#fefefe",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "0.94571567px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3642",
    d: "m 232.25896,185.83056 5.2356,-3.75862 0,22.8023 -6.03231,6.64023 -11.72317,0 0,112.38277 -10.69882,27.81381 0,-146.83681 19.57656,0 3.64214,-3.25747 0,-15.78621 z",
    style: {
      fill: "#808080",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "0.94571567px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(0.90138601,0,0,0.99222542,-437.42287,-185.30615)",
    d: "m 828.9375,369.5 -4.28125,4.28125 0,15.71875 3.75,3.75 19.8125,0 0,15.1875 -131.0625,132.84375 0,-147.84375 21.78125,0 4.46875,-4.46875 0,-15.90625 -4.125,-3.1875 -114.625,0 -3.75,3.75 0,16.25 3.8125,3.8125 19.9375,0 0,272.25 3.75,3.75 22.65625,0 274.65625,-283.40625 0,-12.5 -4.28125,-4.28125 -112.5,0 z",
    id: "path3622",
    style: {
      fill: "#cccccc",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3636",
    d: "m 415.35268,185.9329 5.49849,-3.49448 0,21.92152 -249.39111,280.5213 -26.47746,0 2.52966,-5.5331 20.28119,0 247.23731,-281.01241 z",
    style: {
      fill: "#808080",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "0.94571567px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3652",
    d: "m 327.29631,205.25009 -5.57703,6.38966 -14.56861,0 3.41452,-6.38966 c 0.11382,0 16.73112,0 16.73112,0 z",
    style: {
      fill: "#808080",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "0.94571567px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.90138601,0,0,0.99222542,-92.530288,-192.23791)",
    id: "g3673"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cccccc",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 8,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeOpacity: 1,
      strokeDasharray: "none"
    },
    id: "path3671",
    d: "m 399.78125,560 a 1.2330102,1.2330102 0 0 0 -0.5625,0.28125 l -5.3125,4.5625 A 1.2330102,1.2330102 0 0 0 393.5625,565.375 L 388.25,580.25 a 1.2330102,1.2330102 0 0 0 0.28125,1.28125 l 4.0625,4.0625 a 1.2330102,1.2330102 0 0 0 0.875,0.34375 l 16.40625,0 a 1.2330102,1.2330102 0 0 0 0.875,-0.34375 l 4.28125,-4.3125 a 1.2330102,1.2330102 0 0 0 0.3125,-0.53125 l 4.5625,-15.65625 a 1.2330102,1.2330102 0 0 0 -0.3125,-1.21875 l -3.53125,-3.53125 A 1.2330102,1.2330102 0 0 0 415.1875,560 l -15.15625,0 a 1.2330102,1.2330102 0 0 0 -0.25,0 z m -30.0625,41.9375 a 1.2330102,1.2330102 0 0 0 -0.9375,0.90625 l -2.03125,8.0625 a 1.2330102,1.2330102 0 0 0 1.1875,1.53125 l 9.65625,0 -23.9375,68.34375 a 1.2330102,1.2330102 0 0 0 1.15625,1.625 l 34.84375,0 a 1.2330102,1.2330102 0 0 0 1.1875,-0.84375 l 2.28125,-7.34375 a 1.2330102,1.2330102 0 0 0 -1.1875,-1.59375 l -7.875,0 23.6875,-69.0625 a 1.2330102,1.2330102 0 0 0 -1.15625,-1.625 l -36.625,0 a 1.2330102,1.2330102 0 0 0 -0.25,0 z m 110.875,0.25 a 1.2330102,1.2330102 0 0 0 -0.6875,0.40625 l -7.25,8.1875 -11.53125,0 -7.6875,-7.96875 a 1.2330102,1.2330102 0 0 0 -0.875,-0.375 l -27.53125,0 A 1.2330102,1.2330102 0 0 0 423.875,603.25 l -2.53125,7.5625 a 1.2330102,1.2330102 0 0 0 1.15625,1.625 l 7.375,0 -22.9375,67.59375 a 1.2330102,1.2330102 0 0 0 1.15625,1.625 l 29.3125,0 a 1.2330102,1.2330102 0 0 0 1.15625,-0.8125 l 2.25,-6.59375 a 1.2330102,1.2330102 0 0 0 -1.15625,-1.625 l -5.125,0 14.625,-46.03125 26.46875,0 -16.6875,53.46875 a 1.2330102,1.2330102 0 0 0 1.1875,1.59375 l 28.28125,0 a 1.2330102,1.2330102 0 0 0 1.125,-0.75 l 2.53125,-6.0625 a 1.2330102,1.2330102 0 0 0 -1.125,-1.6875 l -5.125,0 14.875,-46.8125 25.1875,0 -16.9375,53.71875 a 1.2330102,1.2330102 0 0 0 1.1875,1.59375 l 31.0625,0 a 1.2330102,1.2330102 0 0 0 1.15625,-0.78125 l 2.53125,-6.59375 a 1.2330102,1.2330102 0 0 0 -1.15625,-1.65625 l -6.15625,0 18.71875,-60.78125 a 1.2330102,1.2330102 0 0 0 -0.1875,-1.125 l -5.8125,-7.8125 a 1.2330102,1.2330102 0 0 0 -1,-0.46875 l -22.21875,0 a 1.2330102,1.2330102 0 0 0 -0.90625,0.375 l -7,7.6875 -12.25,0 -7.25,-7.9375 a 1.2330102,1.2330102 0 0 0 -0.90625,-0.375 l -17.90625,0 a 1.2330102,1.2330102 0 0 0 -0.25,0 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 400.03125,561.21875 -5.3125,4.5625 -5.3125,14.875 4.0625,4.0625 16.40625,0 4.28125,-4.3125 4.5625,-15.65625 -3.53125,-3.53125 -15.15625,0 z m -30.0625,41.9375 -2.03125,8.0625 11.375,0 -24.5,69.96875 34.84375,0 2.28125,-7.34375 -9.59375,0 24.25,-70.6875 -36.625,0 z m 110.875,0.25 L 473.25,612 l -12.625,0 -8.0625,-8.34375 -27.53125,0 -2.53125,7.5625 9.09375,0 -23.5,69.21875 29.3125,0 2.25,-6.59375 -6.8125,0 15.40625,-48.46875 29.0625,0 -17.1875,55.0625 28.28125,0 2.53125,-6.0625 -6.8125,0 15.65625,-49.25 27.78125,0 -17.4375,55.3125 31.0625,0 2.53125,-6.59375 -7.84375,0 19.21875,-62.375 -5.8125,-7.8125 -22.21875,0 -7.34375,8.0625 -13.375,0 -7.59375,-8.3125 -17.90625,0 z",
    id: "path3665",
    style: {
      fill: "#cccccc",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeOpacity: 1,
      strokeDasharray: "none"
    }
  })))));
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgVim, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Vim.4459086a.svg";
export { ForwardRef as ReactComponent };